import React from 'react';
import IconToggle from 'components/base/IconToggle';
import { Flex } from 'components/base/layout-components';
import { IconToggleTooltip } from '../notifications.service';

const DashboardCol = ({
  widgetId,
  widgetEnabled,
  toggleWidgetsForTeamDashboard,
  id,
  notificationKey,
  name
}) => {
  return (
    <Flex items='center' justify='center'>
      <IconToggle
        name='addChart'
        checkedName='chartFull'
        size='normal'
        color='shuttleGray'
        checkedColor='malachite'
        isChecked={widgetEnabled}
        tooltipContent={IconToggleTooltip(
          'Add to Team Goals Dashboard',
          'Start tracking this goal'
        )}
        onClick={() =>
          toggleWidgetsForTeamDashboard(
            !widgetEnabled,
            widgetId,
            id,
            notificationKey,
            name
          )
        }
      />
    </Flex>
  );
};

export default DashboardCol;
